import { render, staticRenderFns } from "./EdEitaaDestination.vue?vue&type=template&id=1c20e48e&"
import script from "./EdEitaaDestination.vue?vue&type=script&lang=js&"
export * from "./EdEitaaDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports